import {FormControl, InputLabel, MenuItem, Select, Stack} from '@mui/material';
import Typography from '@mui/material/Typography';
import React, {useCallback, useState} from 'react';
import {vehicleTitle} from '../../../../../formatters';

const Item = ({item, job, updateSelection, loading}) => {
  const [destinationVehicle, setDestinationVehicle] = useState(null);

  const handleSelection = useCallback((event) => {
    const selected = job.vehicles.find((vehicle) => vehicle.id === event.target.value);
    setDestinationVehicle(selected ?? null);
    updateSelection({item_id: item.id, vehicle_id: selected?.id ?? null});
  }, [item, job, updateSelection]);

  return (
    <Stack direction="column" spacing={2}>
      <Typography component="h4" variant="body">
        Vehicle for {item.product.name} (currently on {vehicleTitle(item.vehicle)})
      </Typography>
      <FormControl>
        <InputLabel id={`item-${item.id}-label`}>Select a Vehicle</InputLabel>
        <Select
          labelId={`item-${item.id}-label`}
          id={`item-${item.id}`}
          value={destinationVehicle?.id ?? 0}
          label="Select a Vehicle"
          onChange={handleSelection}
          disabled={loading}
        >
          <MenuItem value={0}>--------</MenuItem>
          {job.vehicles.map((vehicle, index) => (
            <MenuItem key={index} value={vehicle.id}>{vehicleTitle(vehicle)}</MenuItem>
          ))}
        </Select>
      </FormControl>
    </Stack>
  );
}

export default Item;
